/*
  Urun kartinda 2 veya 3 gorseli olan urunlerde hover: mouse'un karti
  yatayda hangi diliminde gezdigine gore ilgili gorsel gosterilir,
  alttaki noktalardan hangisinde oldugumuz gorunur.

  Not: Dinleyici .media--hover-cycle degil, .card-wrapper uzerinde -
  kartin tamamini kaplayan (urune gitmek icin) goruunmez link katmani
  gercek mousemove hedefini kendi ustune aliyor, container kendi
  basina bu event'i hicbir zaman almiyordu.
*/
document.addEventListener('DOMContentLoaded', function () {
  var cards = document.querySelectorAll('.card-wrapper');

  cards.forEach(function (card) {
    var container = card.querySelector('.media--hover-cycle');
    if (!container) return;

    var imgs = container.querySelectorAll('.card__hover-cycle-img');
    var dots = container.querySelectorAll('.card__hover-cycle-dot');
    if (imgs.length < 2) return;

    function setActive(index) {
      imgs.forEach(function (img, i) {
        img.style.opacity = i === index ? '1' : '0';
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function reset() {
      imgs.forEach(function (img) {
        img.style.opacity = '';
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === 0);
      });
    }

    card.addEventListener('mousemove', function (event) {
      var rect = container.getBoundingClientRect();
      if (event.clientY < rect.top || event.clientY > rect.bottom) {
        return;
      }
      var relativeX = (event.clientX - rect.left) / rect.width;
      relativeX = Math.min(0.999, Math.max(0, relativeX));
      setActive(Math.floor(relativeX * imgs.length));
    });

    card.addEventListener('mouseleave', reset);
  });
});
